<template>
  <div class="card-list">
    <div
      class="card"
      v-for="(cardItem, key) in cardList"
      :key="key"
      @click="navigation(cardItem.current, cardItem.url)"
      :style="{
        backgroundImage: `url(${cardItem.imgUrl})`,
      }"
    >
      <div class="title">{{ cardItem.title }}</div>
      <div class="sub-title">{{ cardItem.subTitle }}</div>
      <img
        src="https://editor.xesimg.com/tailor/resource/%E5%8E%BB%E6%9F%A5%E7%9C%8B2-1702192048786.png"
        alt=""
      />
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const cardList = [
  {
    imgUrl: "https://editor.xesimg.com/tailor/resource/bg1-1702191659266.png",
    title: "线下素养课",
    subTitle: "科学思维、人文创作、编程",
    url: "https://www.speiyou.com/download",
    current: false,
  },
  {
    imgUrl: "https://editor.xesimg.com/tailor/resource/BG2-1702191659267.png",
    title: "线上素养课",
    subTitle: "人文创作、编程与机器人、博物",
    url: "https://online.xueersi.com",
    current: false,
  },
  {
    imgUrl: "https://editor.xesimg.com/tailor/resource/bg3-1702191659268.png",
    title: "学习硬件",
    subTitle: "学而思学习机",
    url: "https://xpad.xueersi.com",
    current: false,
  },
  {
    imgUrl: "https://editor.xesimg.com/tailor/resource/BG4-1702191659268.png",
    title: "智能图书",
    subTitle: "摩比爱系列、摩比思维机",
    url: "/ibook",
    current: true,
  },
  {
    imgUrl: "https://editor.xesimg.com/tailor/resource/BG5-1702191659269.png",
    title: "考研留学",
    subTitle: "雅思、托福、考研",
    url: "https://www.qz100.com/home",
    current: false,
  },
];
const navigation = (current, url) => {
  if (current) {
    router.push(url);
    return;
  }
  window.open(url, "_blank");
};
</script>

<style scoped lang="less">
.card-list {
  display: flex;
  flex-wrap: wrap;
  width: 1200px;
  margin: 0 auto 78px;
  justify-content: space-between;
  align-items: center;
  .card {
    cursor: pointer;
    padding: 16px;
    box-sizing: border-box;
    position: relative;
    width: 223px;
    height: 140px;
    background-size: 100% 100%;
    .title {
      color: #000;
      font-family: PingFang SC;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      margin-top: 8px;
    }
    .sub-title {
      color: #000;
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-top: 8px;
      white-space: nowrap;
    }
    img {
      width: 79px;
      height: 26px;
      display: block;
      margin-top: 18px;
    }
  }
}
</style>
